import { RefObject, useEffect } from 'react';

type UseInfiniteScrollArgs = {
  rootRef: RefObject<HTMLElement | null>;
  triggerRef: RefObject<HTMLElement | null>;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onLoadMore?: () => void;
  rootMargin?: string;
};

export const useInfiniteScroll = ({
  rootRef,
  triggerRef,
  hasNextPage = false,
  isFetchingNextPage = false,
  onLoadMore,
  rootMargin = '120px 0px',
}: UseInfiniteScrollArgs) => {
  useEffect(() => {
    if (!onLoadMore || !hasNextPage || isFetchingNextPage) {
      return undefined;
    }

    const root = rootRef.current;
    const trigger = triggerRef.current;

    if (!root || !trigger) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          onLoadMore();
        }
      },
      {
        root,
        rootMargin,
      }
    );

    observer.observe(trigger);

    return () => observer.disconnect();
  }, [hasNextPage, isFetchingNextPage, onLoadMore, rootMargin, rootRef, triggerRef]);
};

export default useInfiniteScroll;
